export const TestIds = {
  PayrunTypeId: 'payruntype-id',
};
